<template>
  <div :style="{ width: width, height: height, position: 'relative' }">
    <img src="https://dobay-document-1304378824.file.myqcloud.com/dashboard_mangguo/mango/mango-title.png" alt="" class="title-img" :style="{ width: width, height: height }" />
    <img v-if="current==1" src="https://dobay-document-1304378824.file.myqcloud.com/dashboard_mangguo/mango/title-ani-1.png" alt="" class="title-img" :style="{ width: width, height: height }" />
    <img v-else-if="current==2" src="https://dobay-document-1304378824.file.myqcloud.com/dashboard_mangguo/mango/title-ani-2.png" alt="" class="title-img" :style="{ width: width, height: height }" />
    <img v-else src="https://dobay-document-1304378824.file.myqcloud.com/dashboard_mangguo/mango/title-ani-3.png" alt="" class="title-img" :style="{ width: width, height: height }" />
    <div class="text-left">{{ textLeft }}</div>
    <div class="text-right">
      <span class="text-right1">{{ textRight1 }}</span
      ><span class="text-right2">
        <slot></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      current:1,
    }
  },
  created(){
    this.current = Math.ceil(Math.random()*3);
  },
  props: {
    width: {
      default: "2.3438rem",
    },
    height: {
      default: ".1563rem",
    },
    textLeft: {
      default: "左侧文字",
    },
    textRight1: {
      default: "",
    },
    textRight2: {
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.title-img{
  position: absolute;
  left: 0;
  top: 0;
}
.text-left {
    position: absolute;
    left: .1406rem;
    top: 50%;
    transform: translate(0, -50%);
    font-family: Alibaba PuHuiTi 3.0;
    font-size: .0833rem;
    font-weight: 600;
    line-height: .125rem;
    letter-spacing: 0em;
    font-variation-settings: "opsz" auto;
    background: linear-gradient(180deg, #FFFFFF 26%, #F1E4D0 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    // text-shadow: 0px 0px .0365rem rgba(228, 162, 90, 0.69),0px .0156rem 0px rgba(0, 0, 0, 0.302);
}
.text-right {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  color: white;
  display: flex;
  align-items: center;
  .text-right1 {
    font-size: 0.0625rem;
    color: #bcd2ed;
    margin-right: 0.0313rem;
  }
  .text-right2 {
    font-size: 0.0625rem;
    color: #ffffff;
    font-size: 600;
  }
}
</style>
